
export interface Person {
  id: number;
  nama: string;
}

/** Resolve the id the v-autocomplete should show as selected, from the bound value. */
export function resolveSelectedId(
  list: Person[],
  value: unknown,
  valueMode: "id" | "nama"
): number | string | null {
  if (valueMode === "nama") {
    if (value === null || value === undefined || value === "") {
      return null;
    }
    const hit = list.find(it => it.nama === value);
    return hit ? hit.id : null;
  }
  // id mode: allow value to be a plain id or a { id } object
  if (value && typeof value === "object") {
    return (value as Person).id;
  }
  return (value as number | string | null) ?? null;
}

/** Resolve what to emit to the parent when the user selects `id`. */
export function resolveEmit(
  list: Person[],
  id: unknown,
  valueMode: "id" | "nama"
): number | string | null {
  if (valueMode === "nama") {
    const hit = list.find(it => it.id === id);
    return hit ? hit.nama : null;
  }
  return (id as number | string | null) ?? null;
}
